import { atom } from 'recoil';
import { sessionStorageEffect } from '../effects/sessionStorageEffect';
import { SpeedTestStatus } from 'types/NetworkScan/SpeedTestStatus';

export interface NetworkScanState {
  scanState: SpeedTestStatus;
}

export const networkScanState = atom<NetworkScanState>({
  key: 'networkState',
  default: {
    scanState: SpeedTestStatus.none,
  },
  effects: [sessionStorageEffect('networkState', ['scanState'])],
});
